import {
  IDestinationEntityHandler,
  type IDestination,
} from '@principle-theorem/practice-migrations/interfaces';
import { BaseDestinationHandler } from '../destination/base-destination-handler';
import { FeeScheduleDestinationEntity } from './destination/entities/fee-schedules';
import { PatientAppointmentDestinationEntity } from './destination/entities/patient-appointments';
import { PatientClinicalChartDestinationEntity } from './destination/entities/patient-clinical-charts';
import { PatientClinicalNoteDestinationEntity } from './destination/entities/patient-clinical-notes';
import { PatientDepositDestinationEntity } from './destination/entities/patient-deposits';
import { PatientFileDestinationEntity } from './destination/entities/patient-files';
import { PatientInteractionDestinationEntity } from './destination/entities/patient-interactions';
import { PatientInvoiceDestinationEntity } from './destination/entities/patient-invoices';
import { PatientRelationshipDestinationEntity } from './destination/entities/patient-relationships';
import { PatientTreatmentPlanDestinationEntity } from './destination/entities/patient-treatment-plans';
import { PatientTreatmentPlanProposalDestinationEntity } from './destination/entities/patient-treatment-plan-proposal';
import { PatientDestinationEntity } from './destination/entities/patients';
import { StafferDestinationEntity } from './destination/entities/staff';
import { PatientSterilisationDestinationEntity } from './destination/entities/sterilisation';
import { PraktikaPatientMedicalHistoryDestinationEntity } from './destination/entities/patient-medical-histories';

export const PRAKTIKA_DESTINATION: IDestination = {
  metadata: {
    name: 'Principle Firestore',
    description: 'Main Principle Migration',
  },
  configuration: [],
};

export class PraktikaDestinationHandler extends BaseDestinationHandler {
  migrationType = 'Praktika';
  migrationVersion = 'v2';
  destination = PRAKTIKA_DESTINATION;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entityHandlers: IDestinationEntityHandler<any, any, any>[] = [
    new PatientDestinationEntity(),
    new PatientRelationshipDestinationEntity(),
    new PatientAppointmentDestinationEntity(),
    new PatientClinicalChartDestinationEntity(),
    new PatientClinicalNoteDestinationEntity(),
    new PatientInvoiceDestinationEntity(),
    new PatientTreatmentPlanDestinationEntity(),
    new PatientFileDestinationEntity(),
    new PatientDepositDestinationEntity(),
    new PatientTreatmentPlanProposalDestinationEntity(),
    new PatientInteractionDestinationEntity(),
    new PatientSterilisationDestinationEntity(),
    new PraktikaPatientMedicalHistoryDestinationEntity(),
    new StafferDestinationEntity(),
    new FeeScheduleDestinationEntity(),
  ];
}
